import { createFileRoute } from '@tanstack/react-router';

import { BillingPage } from '@/features/setting/page/billing-page';

export const Route = createFileRoute('/workspace/$workspaceId/settings/billing')({
  component: RouteComponent,
});

function RouteComponent() {
  return <BillingPage />;
}
